import './css/calendarPage.scss';
import {LOADER_HTML} from "../modulos/topbottom/utils";

const calendarLogic = async () => {
    import('flatpickr/dist/flatpickr.css');

    //Elementos que entran en juego: el input de fecha, el botón del calendario y el div con el resultado
    const calendarInput = document.querySelector('#dateCalendar');
    const calendarButton = calendarInput.parentNode.parentNode;
    const calendarHolder = document.querySelector('#calendarHolder');

    //Mostrar un cargando...
    calendarHolder.innerHTML = LOADER_HTML;

    //Importar Flatpickr y las preferencias en español
    const flatpickr = await import('flatpickr');
    const {Spanish} = await import('flatpickr/dist/l10n/es');

    //Inicializar el calendario
    const calendar = flatpickr.default(calendarInput, {
        defaultDate: calendarInput.dataset.flatpickrDate,
        maxDate: calendarInput.dataset.flatpickrMax,
        minDate: calendarInput.dataset.flatpickrMin,
        locale: Spanish
    });

    //Obtiene los eventos para la zona y fechas y crea el contenido
    const loadCalendar = () => {
        const url = unmaskpath(calendarHolder.dataset.url);
        const zone = calendarHolder.dataset.zone;
        const customDate = calendarInput.value || calendarInput.dataset.flatpickrDate;
        calendarHolder.innerHTML = LOADER_HTML;

        fetch(url + '/' + customDate + zone)
            .then(response => response.text())
            .then(response => {
                calendarHolder.innerHTML = response;
                //BITBAN DEPENDENCY
                app.tabs.init($(calendarHolder));
            })
            .catch(err => {
                calendarHolder.innerHTML = '<div class="error-calendar">Hubo un error al cargar el calendario. Inténtelo pasados unos minutos</div>';
            });
    }

    //Al cambiar la fecha, actualziar el contenido
    calendar.set("onChange", (d) => {
        loadCalendar();
    });

    //Al hacer clic en el icono del calendario (al lado de la fecha), mostrar calendario.
    calendarButton.addEventListener('click', (e) => {
        calendar.open();
        e.stopPropagation();
    });

    loadCalendar();
}
export const calendarPage = () => {
    calendarLogic();

}